import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_BORJOMI:IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'borjomi',
  start_page: 'orders',
  language: {
    defaultLang: 'ru',
    showLang: false,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,
      showLinkToFAQ: true,
      loginType: 'common',
      goFAQ: 'https://borjomi.redfactory.io/img/FAQ.pdf',
      supportEmail: 'support@redfactory.io',
      enableSelfRegistration: true,
      enableGoogleSignIn: false,
      showTutorialVideo: false,
      showTryDemoButton: false,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    orders:{
      showStock: true
    },
    main: {
      showSupportBlock: false,
    }
  }
};


export const CONFIGURATION_BORJOMI_DEV:IConfiguration = {
  ...CONFIGURATION_BORJOMI
};
export const CONFIGURATION_BORJOMI_PROD:IConfiguration = {
  ...CONFIGURATION_BORJOMI
};
